import { useMutation } from "@tanstack/react-query";
import { userApi } from "@repo/api";
import { Logger } from "@saviynt/common";

export const useReserUserPassword = () => {
  const { mutate, isError, isSuccess } = useMutation({
    mutationFn: (payload: { email: string }) => userApi.resetPassword(payload),
    onError: (error) => {
      Logger.error("Error reseting user password:", error);
    },
    onSuccess: (data) => {
      Logger.log("Successfully reset user password:", data);
    },
  });

  return { mutate, isError, isSuccess };
};
